"use client";
import NextLink from "next/link";
import { usePathname } from "next/navigation";

export const Footer = () => {
	const pathname = usePathname();
	const disableProppi =
		pathname?.endsWith("events/suzuka2024/detail") ||
		pathname?.endsWith("events/suzuka2025/detail");

	const isSuzuka2024 = pathname?.endsWith("events/suzuka2024/detail");
	const isSuzuka2025 = pathname?.endsWith("events/suzuka2025/detail");
	const isWakayama2024 = pathname?.endsWith("events/wakayama2024/detail");
	const is2024techfes =
		pathname?.endsWith("events/2024techfes/detail") ||
		pathname?.endsWith("events/2024techfes/lecture") ||
		pathname?.endsWith("events/2024techfes/hackathon");

	const bgColor = isSuzuka2024
		? "bg-suzuka2024hot"
		: isSuzuka2025
			? "bg-suzuka2025purple"
			: is2024techfes
				? "bg-techfes2024"
				: isWakayama2024
					? "bg-wakayama2024"
					: "bg-sky-100";

	const fontColor = isSuzuka2024
		? "text-suzuka2024naby"
		: isSuzuka2025
			? "text-white"
			: is2024techfes
				? "text-techfes2024"
				: "text-sky-600";

	return (
		<div className={`h-200 flex flex-col items-center ${fontColor}`}>
			{disableProppi || (
				<div
					className={
						"flex justify-end w-11/12 md:w-7/12 lg:w-7/12 max-w-[1200px]"
					}
				>
					<img
						src={"/png/proppi.png"}
						className={"w-14 h-auto"}
						alt={"proppi"}
					/>
				</div>
			)}
			<div
				className={`flex flex-col items-center ${bgColor}  py-16 gap-4 w-full`}
			>
				<p className={"font-bold text-3xl"}>Startup Hub Kosen</p>
				<div className={"flex flex-col gap-4 md:flex-row"}>
					<NextLink
						className={"text-sm"}
						href={"https://prossell.jp"}
						target={"_blank"}
						rel={"noopener noreferrer"}
					>
						運営会社
					</NextLink>
					<NextLink
						className={"text-sm"}
						href={"PrivacyPolicy.pdf"}
						target={"_blank"}
						rel={"noopener noreferrer"}
					>
						プライバシーポリシー
					</NextLink>
					<NextLink className={"text-sm"} href={"/legal"}>
						特別商取引法に基づく表記
					</NextLink>
					<NextLink
						className={"text-sm"}
						href={"https://prossell.jp/contact"}
						target={"_blank"}
						rel={"noopener noreferrer"}
					>
						お問い合わせ
					</NextLink>
				</div>
				<p className={"text-sm"}>
					Copyright © 2024 Prossell,inc. All Rights Reserved.
				</p>
			</div>
		</div>
	);
};
